import React from 'react';
import {Button, Col, ConfigProvider, Form, Input, Modal, Row} from 'antd';
import Colors from "../../../styles/Colors";
import {BiCheck, BiX} from "react-icons/bi";
import locale from "antd/es/locale/es_ES";
import { PutAlergens } from '../../../dao/alergens/PutAlergensId';
import Alergen from '../../../model/inscripcions/Alergen';
import TextArea from 'antd/es/input/TextArea';

interface AlergenstModalProps {
    element: Alergen;
    visible: boolean;
    onClose: (value: boolean) => void;
    editar?: boolean;
    page: string;

}

const AlergensModal: React.FC<AlergenstModalProps> = ({element, visible, onClose, editar, page}) => {
    const [form] = Form.useForm();

    async function handleSubmit () {
        const formData = form.getFieldsValue();
        console.log("Form Data:", formData);
        console.log(JSON.stringify(formData));
        await PutAlergens(formData, page);

        onClose(true);
    };

    const handleCancel = () => {
        onClose(false);
    };

    return (
        <ConfigProvider locale={locale}>
        <Modal
            title="Crear/Editar Al·lergen"
            open={visible}
            onCancel={handleCancel}
            footer={[
            ]}
            width={650}
        >
            <Form form={form} initialValues={element} onFinish={handleSubmit}  disabled={!editar} >
                <hr/>
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Form.Item label="ID" name="id">
                            <Input disabled/>
                        </Form.Item>
                        <Form.Item label="Nom" name="nom"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input/>
                        </Form.Item>
                        <Form.Item label="Número" name="num"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input type="number"/>
                        </Form.Item>
                    </Col>     
                     <Col>
                        <Form.Item label="Comentaris" name="comentaris"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <TextArea rows={5} cols={30} />
                        </Form.Item>
                    </Col>
                   
                </Row>
                <hr/>
                <Row gutter={[16, 16]}>
                    <Col span={1}>
                        <Form.Item wrapperCol={{offset: 0, span: 16}}>
                            <Button title={"Aceptar"} htmlType={"submit"}
                                    style={{backgroundColor: Colors.colors.color6}}><BiCheck/></Button>
                        </Form.Item>
                    </Col>
                    <Col span={1}>
                    </Col>
                    <Col span={1}>
                        <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                                onClick={handleCancel}><BiX/></Button>
                    </Col>
                </Row>
            </Form>
        </Modal>
        </ConfigProvider>
    );
};

export default AlergensModal;
